// Shim. The on-change fill-rule editor moved to the shared package
// (@twasta/page-runtime/designerKit), where it reads tables and columns from an
// injected DesignerCatalog. This wrapper supplies the builder's catalog
// (./designerCatalog), so every importer keeps its props and behaviour.
import type { ComponentProps } from 'react'
import { ItemChangeRuleEditor as KitItemChangeRuleEditor } from '@twasta/page-runtime/designerKit'
import { usePlatformDesignerCatalog } from './designerCatalog'

type Props = Omit<ComponentProps<typeof KitItemChangeRuleEditor>, 'catalog'>

export default function ItemChangeRuleEditor(props: Props) {
  const { catalog, confirmDialog } = usePlatformDesignerCatalog(props.project)
  return (
    <>
      <KitItemChangeRuleEditor {...props} catalog={catalog} />
      {confirmDialog}
    </>
  )
}
